import "./index.css";
import Logo from "@/assets/illustrations/logo.png";
import { Link, useNavigate } from "react-router";
import { AvatarMenu } from "./AvatarMenu";
import { Nav } from "./Nav";
import { MobileMenuToggle } from "../../AppLayout/MobileMenu";
import { useUserRole } from "@/hooks/useUserRole";
import { AuthState } from "@/types/common";
import { NotificationButton } from "@/components/Notifications";
import { Button } from "@/ui-kit";
import { useTranslation } from "react-i18next";
import { ROUTES } from "@/router";
import { useAppStore } from "@/store/app/slice";

export const AppHeader = () => {
  const { t } = useTranslation();
  const { isSuperAdmin } = useUserRole();
  const authenticated = useAppStore((s) => s.authenticated);
  const navigate = useNavigate();
  const isAuthenticated = authenticated === AuthState.Authenticated;

  const navigateToAuth = () => {
    navigate(`/${ROUTES.AUTH}/${ROUTES.SIGN_IN}`);
  };

  const defaultUrl = isSuperAdmin ? ROUTES.TENANTS : ROUTES.PROJECTS;

  return (
    <header className="nuco-header">
      <div className="app-header__inner">
        <div className="nuco-header__left">
          <Link to={defaultUrl} className="nuco-header__logo-link">
            <img src={Logo} alt="QuickConnex" className="nuco-header__logo-img" />
          </Link>
          <Nav />
        </div>
        <div className="nuco-header__right">
          {isAuthenticated ? (
            <>
              {!isSuperAdmin && <NotificationButton />}
              <AvatarMenu />
            </>
          ) : (
            <Button
              size="sm"
              content={t("action.sign_in")}
              onClick={navigateToAuth}
            />
          )}

          <MobileMenuToggle />
        </div>
      </div>
    </header>
  );
};
